/* eslint-disable react/no-danger */
import React, { createRef, useState } from 'react';
import { arrayOf, bool, node, oneOfType, string } from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import HorizontalFlow from '../HorizontalFlow';
import {
  AccordionContainer,
  AccordionContent,
  AccordionHeader,
  AccordionTrigger,
} from './styles';

function Accordion({ children, header, actions, isCollapsed, caretPosition }) {
  const [collapsed, setCollapsed] = useState(isCollapsed);

  const headerRef = createRef();
  const handleHeaderClick = (e) => {
    if (!headerRef.current.contains(e.target)) return false;
    const btns = headerRef.current.querySelectorAll('a, button');
    let btnClicked = false;
    btns.forEach((x) => {
      if (x === e.target || x.contains(e.target)) btnClicked = true;
    });
    if (btnClicked) return false;
    setCollapsed(!collapsed);
    return true;
  };

  const accordionContent = {
    left: (
      <>
        <HorizontalFlow>
          <AccordionTrigger
            className={`icon-${
              collapsed ? 'right-arrow' : 'down-arrow'
            } icon--28`}
            collapsed={collapsed}
          />
          {header}
        </HorizontalFlow>
        <HorizontalFlow spacing='0rem'>{actions}</HorizontalFlow>
      </>
    ),
    right: (
      <>
        {header}
        <HorizontalFlow>
          <AccordionTrigger
            className={`icon-${
              collapsed ? 'right-arrow' : 'down-arrow'
            } icon--28`}
            collapsed={collapsed}
          />
          <HorizontalFlow spacing='0rem'>{actions}</HorizontalFlow>
        </HorizontalFlow>
      </>
    ),
  }[caretPosition];

  return (
    <AccordionContainer collapsed={collapsed}>
      <AccordionHeader ref={headerRef} onClick={handleHeaderClick}>
        {accordionContent}
      </AccordionHeader>
      <AccordionContent>{children}</AccordionContent>
    </AccordionContainer>
  );
}

Accordion.defaultProps = {
  children: [],
  isCollapsed: true,
  actions: [],
  header: [],
  caretPosition: 'left',
};

Accordion.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  header: oneOfType([arrayOf(node), node]),
  actions: oneOfType([arrayOf(node), node]),
  caretPosition: string,
  isCollapsed: bool,
};

function AccordionFallback() {
  return <AccordionContainer />;
}

export default exportWithBoundary(Accordion, AccordionFallback);
